<template>
  <div v-if="addQuestionTemplate === 'default'" class="mt-4">
    <div
      class="label-area mb-4"
      :style="{
        color: textColor || '#000000',
      }"
    >
      {{ text }}
    </div>
    <hr />
  </div>

  <div v-else>
    <div class="mt-4">
      <div
        style="display: flex; align-items: center; justify-content: center;"
        class="label-area mb-4"
        :style="{
          color: textColor || '#000000',
        }"
      >
        {{ text }}
      </div>
      <hr />
    </div>
  </div>
</template>

<script>
export default {
  name: 'LabelQuestion',

  props: {
    textColor: { type: String, required: false },
    text: { type: String, required: true },
    addQuestionTemplate: { type: String, required: true, default: 'default' },
  },
};
</script>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';

.label-area {
  display: flex;
  flex-direction: row;
  font-weight: bold;
}

@media only screen and (max-width: 1200px) {
  .label-area {
    justify-content: center;
    align-items: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/metrics/label-question/index.vue